export const listSensorGroups = /* GraphQL */ `
  query ListSensorGroups(
    $filter: ModelSensorGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSensorGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        type
        messages {
            status
            message
            color
            value
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const listCameraTrafficVolumns = /* GraphQL */ `
  query ListCameraTrafficVolumns(
    $cameraId: ID
    $timestamp: ModelStringKeyConditionInput
    $filter: ModelCameraTrafficVolumeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCameraTrafficVolumns(
      cameraId: $cameraId
      timestamp: $timestamp
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        cameraId
        timestamp
        data
        # createdAt
        # updatedAt
        # __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserDeviceGroups = /* GraphQL */ `
  query GetUserDeviceGroups($userId: ID!) {
    getUserDeviceGroups(userId: $userId) {
      userId
      group1 {
        name
        devices {
          id
          directions
        }
        __typename
      }
      group2 {
        name
        devices {
          id
          directions
        }
        __typename
      }
      group3 {
        name
        devices {
          id
          directions
        }
        __typename
      }
      group4 {
        name
        devices {
          id
          directions
        }
        __typename
      }
      group5 {
        name
        devices {
          id
          directions
        }
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
